import { generatePath } from 'react-router';
import { makeAutoObservable } from 'mobx';

import { IconName } from '@/common/components/Icon/iconName';
import { DRIVE_PAGE } from '@/common/constants/pages';
import { DriveTreeItem } from '@/drive/entities/DriveTreeItem/DriveTreeItem';
import { DriveSection } from '@/drive/types/DriveSection';
import { SectionIconClassName, SectionItem } from '@/drive/types/SectionItem';
import { GlobalAccessLevel } from '@/security/constants/GlobalAccessLevel';

class AppSectionTreeItem implements DriveTreeItem {
  id!: string;
  title: string;

  icon?: IconName;
  iconClassName?: SectionIconClassName;
  children: DriveTreeItem[];
  isExternalUrl?: boolean;

  collapsed?: boolean;

  isSubSection?: boolean;
  isSectionEndAbove?: boolean;

  private readonly url!: string;

  constructor(item: SectionItem) {
    makeAutoObservable<AppSectionTreeItem, 'url'>(this, {
      id: false,
      icon: false,
      iconClassName: false,
      children: false,
      isExternalUrl: false,
      isSubSection: false,
      isSectionEndAbove: false,
      url: false,
    });

    this.id = item.id;
    this.title = item.title;
    this.children = item.children?.map((item) => new AppSectionTreeItem(item)) ?? [];
    this.collapsed = item.collapsed ?? true;
    this.icon = item.icon;
    this.url = AppSectionTreeItem.resolveUrl(item);
    this.isExternalUrl = !!item.isExternalUrl;
    this.iconClassName = item.iconClassName;
    this.isSubSection = !!item.isSubSection;
    this.isSectionEndAbove = !!item.isSectionEndAbove;
  }

  setTitle(title: string) {
    this.title = title;
  }

  getUrl() {
    return this.url;
  }

  getDriveId() {
    if (this.id !== DriveSection.DriveRoot) {
      throw new Error('Drive operations supported only for root section');
    }

    return null;
  }

  getAccess() {
    return GlobalAccessLevel.Restricted;
  }

  private static resolveUrl(item: SectionItem): string {
    if (item.url) {
      return item.url;
    }

    if (item.id === DriveSection.DriveRoot) {
      return generatePath(DRIVE_PAGE);
    }

    return generatePath(DRIVE_PAGE, { section: item.id });
  }
}

export default AppSectionTreeItem;
